<template>
<el-container style="min-height: 100%;">
    <el-main style="background-color: #fff;display: flex;flex-direction: column;">
        <div class="search-container">
            <div class="left-part" :class="{ 'collapsed': !searchShow }">
                <el-input placeholder="用户手机" v-model="search.phone" clearable size="small" style="width: 150px;" />
                <el-input placeholder="用户姓名" v-model="search.name" clearable size="small" style="width: 150px;" />
                <el-input placeholder="单号" v-model="search.order_no" clearable size="small" style="width: 200px;" />
                <el-input placeholder="快递单号" v-model="search.express_no" clearable size="small" style="width: 200px;" />
                <el-input placeholder="商品名称" v-model="search.good_name" clearable size="small" style="width: 200px;" />
                <el-select placeholder="商品类型" v-model="search.good_type" clearable size="small" style="width: 120px;">
                    <el-option label="标准商品" :value="1"></el-option>
                    <el-option label="定制商品" :value="4"></el-option>
                    <el-option label="礼品" :value="5"></el-option>
                    <el-option label="赠品" :value="6"></el-option>
                </el-select>
                <el-select placeholder="支付方式" v-model="search.pay_type" clearable size="small" style="width: 120px;">
                    <el-option label="预付定金" :value="1"></el-option>
                    <el-option label="预付全款" :value="2"></el-option>
                    <el-option label="货到付款" :value="3"></el-option>
                    <el-option label="售后补货" :value="4"></el-option>
                </el-select>
                <el-cascader v-model="search.depart_id" clearable :options="departArr" :props="{value:'id',label:'name',checkStrictly:true,multiple: true}" size="small" @visible-change="getDepartmentLists" placeholder="所属部门 "></el-cascader>
                <!-- <el-input placeholder="所属员工账号" v-model="search.admin_phone" size="small" clearable /> -->
                <el-select v-model="search.created_by" clearable filterable size="small" placeholder="所属员工" style="margin-left: 10px;" @visible-change="selectAdmin">
                    <el-option v-for="(item,index) in adminList" :key="index" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id"></el-option>
                </el-select>
                <el-date-picker v-model="search.created_time" type="datetimerange" clearable value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="创建开始时间" end-placeholder="创建结束时间" size="small" placeholder="创建时间范围" />
                <el-date-picker v-model="search.check_time" type="datetimerange" clearable value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="审核开始时间" end-placeholder="审核结束时间" size="small" placeholder="审核时间范围" />
                <el-date-picker v-model="search.send_time" type="datetimerange" clearable value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="发货开始时间" end-placeholder="发货结束时间" size="small" placeholder="发货时间范围" />
                <el-date-picker v-model="search.updated_time" type="datetimerange" clearable value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="更新开始时间" end-placeholder="更新结束时间" size="small" placeholder="更新时间范围" />
                <el-input placeholder="合计金额最少" v-model.number="search.pay_amount_min" size="small" clearable style="width: 150px;"/>
                <el-input placeholder="合计金额最多" v-model.number="search.pay_amount_max" size="small" clearable style="width: 150px;"/>
                <el-select placeholder="排序方式" v-model="search.sort_type" clearable size="small">
                    <el-option label="合计金额" value="pay_amount"></el-option>
                    <el-option label="预付金额" value="pre_money"></el-option>
                    <el-option label="应付金额" value="to_receive_money"></el-option>
                </el-select>
            </div>
            <div class="right-part">
                <a class="_color" @click="searchShow = !searchShow" > {{ searchShow ? '收缩' : '展开' }} </a>
                <el-button size="small" @click="getOrderLists(1)">筛选</el-button>
                <!-- <div class="_button mr_10 " style="height: 22px;" @click="exportVisible=true" v-permit="'/admin/crm/orderAdd'">创建订单</div> -->
                <el-button size="small" type="warning" @click="exportVisible=true" v-permit="'/admin/crm/orderExport'">导出</el-button>
                <!-- <el-button size="small" type="primary" @click="importVisible=true" v-permit="'/admin/crm/orderImportExpress'">导入物流</el-button>
                <el-button size="small" type="success" @click="comfirmVisible=true" v-permit="'/admin/crm/orderBatchConfirm'">批量确款</el-button> -->
                <el-dropdown @command="batchImport">
                    <el-button size="small" type="primary">导入<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="express" v-permit="'/admin/crm/orderImportExpress'">导入物流</el-dropdown-item>
                        <el-dropdown-item command="receive" v-permit="'/admin/crm/orderBatchReceive'">批量签收</el-dropdown-item>
                        <el-dropdown-item command="confirm" v-permit="'/admin/crm/orderBatchConfirm'">批量确款</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <el-button size="small" type="info" @click="getJdStatus" v-permit="'/admin/crm/jdStatus'" :loading="jdStatusLoading">同步京东</el-button>
            </div>
        </div>

        <el-tabs v-model="search.state" type="card" @tab-click="getOrderLists(1)">
            <el-tab-pane label="全部" name="0"></el-tab-pane>
            <el-tab-pane v-for="state in stateArr" :label="state.name" :name="state.code + ''"></el-tab-pane>
        </el-tabs>
        <div style="flex: 1;">
            <el-table :data="list" stripe height="100%" :header-cell-style="{ background:'#f5f5f5'}" v-loading="tableLoading" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="id" label="订单" min-width="250">
                    <template v-slot="{row}">
                        <div><span class="_color" :title="row.id">单号：</span>{{row.order_no}}</div>
                        <div><span class="_color">用户：</span>{{row.user.name}} {{row.user.phone}}</div>
                        <div style="display: flex;align-items: center;">
                            <div class="_color" style="min-width: 46px;">地址：</div>
                            <el-tooltip :content="row.receive_province + row.receive_city + row.receive_area + row.receive_street + row.receive_address" placement="top-start">
                                <span style="max-width:400px;display: inline-block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{row.receive_province}}{{row.receive_city}}{{row.receive_area}}{{row.receive_street}}{{row.receive_address}}</span>
                            </el-tooltip>
                        </div>
                        <div><span class="_color">备注：</span>{{row.remark}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="商品" min-width="250">
                    <template v-slot="{row}">
                        <div v-for="(item, gi) in row.goods" :key="item.id">
                            <el-divider v-if="gi"></el-divider>
                            <div style="display: flex;align-items: center;">
                                <div class="_color" style="min-width: 46px;">商品：</div>
                                <el-tooltip :content="item.good_name_full" placement="top-start">
                                    <span style="max-width:400px;display: inline-block;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.good_name_full}}</span>
                                </el-tooltip>
                            </div>
                            <div><span class="_color">规格：</span>{{item.spec_data_str}}</div>
                            <div><span class="_color">重量：</span>{{item.weight}}</div>
                            <div><span class="_color">单价：</span>{{item.sale_price}} <span class="_color">数量：</span>{{item.quatity}}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="金额" min-width="120" max-width="180">
                    <template v-slot="{row}">
                        <div><span class="_color">商品：</span>{{row.good_amount}}</div>
                        <div><span class="_color">预付：</span>{{row.pre_money}}</div>
                        <div><span class="_color">代收：</span>{{row.collect_money}}</div>
                        <div><span class="_color">合计：</span>{{row.pay_type == 4 ? '0' : row.pay_amount}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="发货" min-width="150" max-width="200">
                    <template v-slot="{row}">
                        <div><span class="_color">方式：</span>{{row.deliver_type_text}}</div>
                        <div><span class="_color">物流：</span>{{row.express_name}}</div>
                        <div><span class="_color">运单：</span>{{row.express_no}}</div>
                        <div>
                            <span class="_color">进度：</span>{{row.state_text}}
                            <i class="el-icon-edit" style="margin-left: 10px;font-size: 16px;cursor: pointer;" v-if="checkAuth('/admin/crm/orderStateChange')" @click="openState(row)"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="回款" min-width="180" max-width="200">
                    <template v-slot="{row}">
                        <div><span class="_color">方式：</span>
                            {{row.pay_type_text}}
                            <span v-if="row.pay_type == 1">,预付{{row.pre_money}},应收{{(row.pay_amount - row.pre_money).toFixed(2)}}</span>
                        </div>
                        <div><span class="_color">回款：</span><span v-if="row.state == 70">{{(row.pay_amount - row.pre_money).toFixed(2)}}</span></div>
                        <div><span class="_color">跟单：</span>{{row.follow_state_text}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="id" label="业务" width="220">
                    <template v-slot="{row}">
                        <div><span class="_color">部门：</span>{{row.depart_name}}</div>
                        <div><span class="_color">入单：</span><span v-if="row.admin">{{row.admin.nick_name}} {{row.admin.phone.slice(-4)}}</span></div>
                        <div><span class="_color">时间：</span>{{row.created_time}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200px" align="center">
                    <template v-slot="{row}">
                        <div class="button-container">
                            <el-button type="primary" size="mini" v-if="checkAuth('/admin/crm/orderEdit')"                         @click="handleAction('edit', row)">编辑</el-button>
                            <el-button type="warning" size="mini" v-if="row.can_check && checkAuth('/admin/crm/orderCheck')"       @click="handleAction('audit', row)">审核</el-button>
                            <el-button type="success" size="mini" v-if="row.can_pay && checkAuth('/admin/crm/orderPay')"           @click="handleAction('pay', row)">支付</el-button>
                            <el-button type="primary" size="mini" v-if="row.can_send && checkAuth('/admin/crm/orderSend')"         @click="handleAction('ship', row)">发货</el-button>
                            <el-button type="info"    size="mini" v-if="row.express_no && checkAuth('/admin/crm/orderLogistics')"  @click="handleAction('logistics', row)">物流</el-button>
                            <el-button type="success" size="mini" v-if="row.can_follow && checkAuth('/admin/crm/orderFollow')"     @click="handleAction('follow', row)">跟单</el-button>
                            <el-button type="primary" size="mini" v-if="row.can_receive && checkAuth('/admin/crm/orderReceive')"   @click="handleAction('sign', row)">签收</el-button>
                            <el-button type="success" size="mini" v-if="row.can_confirm && checkAuth('/admin/crm/orderConfirm')"   @click="handleAction('confirm', row)">确款</el-button>
                            <el-button                size="mini" v-if="checkAuth('/admin/crm/orderDetail')"                       @click="handleAction('print', row)">打印</el-button>
                            <el-button type="danger"  size="mini" v-if="row.can_cancel && checkAuth('/admin/crm/orderCancel')"     @click="handleAction('cancel', row)">取消</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog title="订单详情" :visible="orderVisible" width="70%" center @close="orderVisible=false" destroy-on-close>
            <CrmOrder v-if="orderVisible" :user="currentOrder.user" :order_id="currentOrder.id" @close="orderVisible = false;getOrderLists()"></CrmOrder>
        </el-dialog>

        <el-dialog title="订单签收" :visible="signVisible" width="500px" center @close="signVisible=false" destroy-on-close style="flex: 1 0 0;">
            <el-radio-group v-model="signState">
                <el-radio :label="60">正常签收</el-radio>
                <el-radio :label="80">客户拒签</el-radio>
            </el-radio-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="signVisible = false">取 消</el-button>
                <el-button type="primary" @click="signOrderHandle">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="订单跟进" :visible="followVisible" width="600px" center @close="followVisible=false" destroy-on-close style="flex: 1 0 0;">
            <el-form label-position="top" label-width="100px" :model="formData" class="pr_20 pl_20">
                <el-form-item label="跟单状态：">
                    <el-radio-group v-model="followForm.follow_state">
                        <el-radio v-for="item in followStateArr" :key="item.code" :label="item.code" :disabled="currentOrder.follow_state > item.code">{{item.name}}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="跟单备注：">
                    <el-input v-model="followForm.content" type="textarea" :rows="5" placeholder="请输入内容"></el-input>
                </el-form-item>
                <div class="_button nul mt_20" style="border: 1px solid #fa9600;color:#fa9600;width: 80px;" @click="todoVisible=true">预约计划</div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="followVisible = false">取 消</el-button>
                <el-button type="primary" @click="followHandle">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="预约计划" :visible="todoVisible" width="600px" center @close="todoVisible=false" destroy-on-close style="flex: 1 0 0;">
            <el-form label-position="top" label-width="100px" :model="todoForm" class="pr_20 pl_20">
                <el-form-item label="时间：">
                    <el-date-picker v-model="todoForm.todo_time" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" class="w200" placeholder="时间" />
                </el-form-item>
                <el-form-item label="事项：">
                    <el-input v-model="todoForm.todo_content" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="todoVisible = false">取 消</el-button>
                <el-button type="primary" @click="todoHandle">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="物流跟踪" :visible="logisticsVisible" width="1000px" center @close="logisticsVisible=false" destroy-on-close style="flex: 1 0 0;">
            <div class="ml_20 f_16 c0">单号: {{currentOrder.express_no}}</div>
            <div class="_scroll mt_20">
                <el-timeline>
                    <el-timeline-item
                      v-for="(log, index) in logisticsData"
                      :key="index"
                      :timestamp="log.time">
                      {{log.context}}
                    </el-timeline-item>
                </el-timeline>
            </div>
        </el-dialog>

        <el-dialog title="导入物流单号" :visible="importVisible" width="500px" center @close="importVisible=false" destroy-on-close style="flex: 1 0 0;">
            <div class="_flex _f_ai">
                <el-upload
                    :headers="{ 'Content-Type': 'multipart/form-data'}" 
                    action="none" 
                    :show-file-list="false" 
                    class="file_uploader"
                    :on-change="handleChange" 
                    :auto-upload="false"
                    ref="upload"
                >
                    <el-button size="small" type="primary">点击上传</el-button>
                    {{upfilename}}
                    <div slot="tip" class="el-upload__tip">请选择含有订单号与物流单号的表格导入,支持文件最大记录行数1000行 <a :href="downloadUrl" download="dindanhaodaoru.xlsx" class="blue ml_10">下载模板</a></div>
                </el-upload>
                </div>
            <div class="t_c mt_40">
                <el-button size="mini" @click="importVisible=false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="uploading" @click="upsubmit">{{uploading ? '上传中' : '确 定'}}</el-button>
            </div>
        </el-dialog>

        <el-dialog title="批量确款" :visible="comfirmVisible" width="500px" center @close="comfirmVisible=false" destroy-on-close style="flex: 1 0 0;">
            <div class="_flex _f_ai">
                <el-upload
                    :headers="{ 'Content-Type': 'multipart/form-data'}" 
                    action="none" 
                    :show-file-list="false" 
                    class="file_uploader"
                    :on-change="handleChange" 
                    :auto-upload="false"
                    ref="upload"
                >
                    <el-button size="small" type="primary">点击上传</el-button>
                    {{upfilename}}
                    <div slot="tip" class="el-upload__tip">请选择含有订单号的表格导入,支持文件最大记录行数1000行 <a :href="downloadUrlquekuan" download="dindanquekuan.xlsx" class="blue ml_10">下载模板</a></div>
                </el-upload>
                </div>
            <div class="t_c mt_40">
                <el-button size="mini" @click="comfirmVisible=false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="uploading" @click="comfirmsubmit">{{uploading ? '上传中' : '确 定'}}</el-button>
            </div>
        </el-dialog>

        <el-dialog title="批量签收" :visible="receiveVisible" width="500px" center @close="receiveVisible=false" destroy-on-close style="flex: 1 0 0;">
            <div class="_flex _f_ai">
                <el-upload
                    :headers="{ 'Content-Type': 'multipart/form-data'}" 
                    action="none" 
                    :show-file-list="false" 
                    class="file_uploader"
                    :on-change="handleChange" 
                    :auto-upload="false"
                    ref="upload"
                >
                    <el-button size="small" type="primary">点击上传</el-button>
                    {{upfilename}}
                    <div slot="tip" class="el-upload__tip">请选择含有订单号的表格导入,支持文件最大记录行数1000行 <a :href="downloadUrlquekuan" download="dindanqianshou.xlsx" class="blue ml_10">下载模板</a></div>
                </el-upload>
                </div>
            <div class="t_c mt_40">
                <el-button size="mini" @click="receiveVisible=false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="uploading" @click="receivesubmit">{{uploading ? '上传中' : '确 定'}}</el-button>
            </div>
        </el-dialog>

        <el-dialog id="printdialog" :title="company.company_name + '业务订单打印'" :visible="printVisible" v-if="currentOrder.id" width="1000px" center @close="printVisible=false" destroy-on-close style="flex: 1 0 0;">
            <h3 style="text-align: center;">{{company.company_name}}业务订单</h3>
            <div style="display: flex;justify-content: space-between;">
                <div style="display: flex;">
                    <div>客户：</div>
                    <div>
                        <div>{{currentOrder.receive_name}}<span style="margin-left: 10px;">{{currentOrder.receive_phone}}</span></div>
                        <div style="margin-top: 10px;">{{currentOrder.receive_province}}{{currentOrder.receive_city}}{{currentOrder.receive_area}}{{currentOrder.receive_street}}</div>
                        <div style="margin-top: 10px;">{{currentOrder.receive_address}}</div>
                    </div>
                </div>
                <div style="display: flex;flex-direction: column;">
                    <div>单号：{{currentOrder.order_no}}</div>
                    <div>打单：{{currentOrder.created_time}}</div>
                </div>
            </div>
            <div style="margin: 10px 0;">备注：{{currentOrder.remark}}</div>
            <el-table :data="currentOrder.goods" stripe :header-cell-style="{ background:'#f5f5f5'}">
                <el-table-column type="index" width="50" label="序号" />
                <el-table-column prop="good_name" label="商品名称"></el-table-column>
                <el-table-column prop="spec_data_str" label="规格"></el-table-column>
                <el-table-column prop="quatity" label="数量"></el-table-column>
                <el-table-column prop="sale_price" label="单价"></el-table-column>
                <el-table-column prop="amount" label="金额"></el-table-column>
            </el-table>
            <div style="display: flex;justify-content: space-between;margin-top: 20px;">
                <div>制单：<span v-if="currentOrder && currentOrder.admin">{{currentOrder.admin.nick_name}} <span style="margin-left: 10px;">{{currentOrder.admin.phone}}</span></span></div>
                <div>客户：{{currentOrder.user.name}} <span style="margin-left: 10px;">{{currentOrder.user.phone}}</span></div>
            </div>
        </el-dialog>

        <el-dialog title="订单导出" :visible="exportVisible" @close="exportVisible=false" :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" top="50vh" width="35%">
            <div style="text-align: left;">
              <div>1、请合理设置筛选条件,筛选出来的数据量太多会导致导出失败</div>
              <div style="margin-top: 10px;">2、导出文件为csv格式，可使用excel或wps打开，可另存为xlsx格式文件</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="" @click="exportVisible = false">取消</el-button>
                <el-button type="primary" @click="orderExport">导出</el-button>
            </span>
          </el-dialog>

          
        <el-dialog title="分配员工" :visible="dispatchVisible" @close="dispatchVisible=false" :close-on-click-modal="false" :close-on-press-escape="false" :destroy-on-close="true" top="50vh" width="300px">
            <div style="text-align: left;">
                <el-select v-model="dispatchAdminId" clearable filterable size="small" placeholder="所属员工" style="margin-left: 10px;" @visible-change="selectAdmin">
                    <el-option v-for="(item,index) in adminList" :key="index" :label="item.nick_name + ' / ' + item.phone" :value="item.admin_id"></el-option>
                </el-select>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="" @click="dispatchVisible = false">取消</el-button>
                <el-button type="primary" @click="dispatchSubmit">确定</el-button>
            </span>
        </el-dialog>
        
        <el-dialog :title="stateTitle" :visible="stateVisible" width="500px" center @close="stateVisible=false" destroy-on-close style="flex: 1 0 0;">
            <el-form label-width="0px">
                <el-form-item label="">
                    <el-select v-model="stateNew" placeholder="请选择状态" style="width: 100%;">
                        <el-option v-for="item in stateArr" :key="item.code" v-if="item.code > 0" :label="item.name" :value="item.code" :disabled="item.code == stateRow.state" ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="t_c mt_40">
                <el-button size="mini" @click="stateVisible=false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="stateloading" @click="statesubmit" :disabled="stateNew == ''">保存</el-button>
            </div>
        </el-dialog>
        </el-main>

        <el-footer class="foot" style="display: flex;align-items: center;background-color: #fff;">
            <div class="_flex_sb">
                <el-button size="small" type="danger">已选择（{{selectedOrders.length}}）</el-button>
                <el-dropdown @command="handleCommand">
                    <el-button size="small" type="primary" style="margin-left: 10px;">批量操作 ></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="check" v-permit="'/admin/crm/orderCheck'">审核通过</el-dropdown-item>
                        <el-dropdown-item command="receive" v-permit="'/admin/crm/orderReceive'">订单签收</el-dropdown-item>
                        <el-dropdown-item command="jdexpress" v-permit="'/admin/crm/orderSend'">京东发货</el-dropdown-item>
                        <el-dropdown-item command="cancel" v-permit="'/admin/crm/orderCancel'">取消订单</el-dropdown-item>
                        <el-dropdown-item command="dispatch" v-permit="'/admin/crm/orderDispath'">分配员工</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <div style="font-size: 20px;margin-left: 20px;"><span class="_color">录单总额：</span>{{pay_amount_total}}</div>
                <div style="font-size: 20px;margin-left: 20px;"><span class="_color">预付总额：</span>{{pre_money_total}}</div>
                <div style="font-size: 20px;margin-left: 20px;"><span class="_color">代收总额：</span>{{collect_money_total}}</div>
            </div>
            <div style="margin-left: auto;">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 50, 100, 500, 1000]" @size-change="changeLimit"
                    @current-change="changePage" :current-page="search.page" :page-size="search.limit" :total="search.total"></el-pagination>
            </div>
        </el-footer>
</el-container>
</template>
<script>
    import { numToRMB } from "@/common/store/util.js"
    import { crmorderLists, crmorderCancel, orderImportExpress, orderBatchConfirm, orderBatchReceive, jdStatus, DepartmentLists, crmorderLogistics, crmorderReceive, crmorderFollow, crmorderConfirm, todoAdd, firmInfoDeatail, crmorderCheck, crmorderSend, adminLists, orderDispath, orderStateChange  } from "@/request/apis.js"
    import CrmOrder from "@/components/crm/Order.vue"
    import base from "@/request/base.js"
    export default {
        components: { CrmOrder },
        data() {
            return {
                searchShow: false,
                tabType: '1',
                alertType: 0,
                name: '',
                formData: {
                    name: ''
                },

                tableLoading: false,
                list: [],
                pay_amount_total: '',
                pre_money_total: '',
                collect_money_total: '',
                stateArr: [],
                followStateArr: [],
                departArr: [],
                adminList: [],
                searchInit: {},
                search: {
                    page: 1,
                    limit: 10,
                    total: 0,
                    state: '0',
                    phone: '',
                    name: '',
                    created_time: [],
                    check_time: [],
                    send_time: [],
                    updated_time: [],
                    created_by: '',
                    order_no: '',
                    express_no: '',
                    good_type: '',
                    pay_type: '',
                    depart_id: [],
                    good_name: '',
                    sort_type: '',
                    pay_amount_min: '',
                    pay_amount_max: '',
                },
                selectedOrders: [],

                currentOrder: {},
                action: '',
                orderVisible: false,

                signType: 0,
                signState: 60,
                signVisible: false,

                followVisible: false,
                followForm: {
                    follow_state: '',
                    content: '',
                },

                logisticsData: [],
                logisticsVisible: false,
                importVisible: false,
                comfirmVisible: false,
                receiveVisible: false,
                uploading: false,
                downloadUrl: base.domain + '/static/crmwuliu.xlsx',
                downloadUrlquekuan: base.domain + '/static/crmquekuan.xlsx',
                upfilename: '',
                mutipartFile: {},
                exportVisible: false,

                todoVisible: false,
                todoForm: {
                    todo_time: '',
                    todo_content: '',
                },

                printVisible: false,
                company: {},

                jdStatusLoading: false,

                dispatchVisible: false,
                dispatchAdminId: '',

                stateloading: false,
                stateVisible: false,
                stateTitle: '',
                stateRow: {},
                stateNew: '',
            }
        },
        mounted() {
            console.log('crmorder mounted', this.$route);
            this.searchInit = {...this.search};
            this.init();
        },
        // activated() {
        //     console.log('crmorder activated', this.$route);
        //     this.search = {...this.searchInit};
        //     this.init();
        // },
        watch: {
            '$route'(to, from) {
                console.log('crmorder watch', to, from)
                if(to.path == '/crmorder' && from.path == '/crmorder'){
                    this.init();
                }
            }
        },
        methods: {
            init(){
                this.search.state = String(this.$route.query.state || 0);
                this.search.good_type = String(this.$route.query.good_type || '');
                this.search.pay_type = String(this.$route.query.pay_type || '');
                this.getOrderLists();
            },
            async getOrderLists(page) {
                if (page) {
                    this.search.page = page;
                }
                this.tableLoading = true;
                var res = await crmorderLists(this.search);
                this.tableLoading = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.list = res.data;
                this.search.total = res.count;
                this.stateArr = res.other.state;
                this.followStateArr = res.other.follow_state;
                this.pay_amount_total = res.other.pay_amount;
                this.pre_money_total = res.other.pre_money;
                this.collect_money_total = res.other.collect_money;
            },
            changeLimit(limit) {
                this.search.limit = limit;
                this.getOrderLists(1);
            },
            changePage(page) {
                this.getOrderLists(page);
            },
            async selectAdmin(query){
                if (!query || this.adminList.length) {
                    return false;
                }
                const res = await adminLists({limit: 1000})
                if (res.code) {
                    return this.$message.error(res.msg)
                }
                this.adminList = res.data;
            },
            async getDepartmentLists(query){
                if (!query || this.departArr.length) {
                    return false;
                }
                var res = await DepartmentLists();
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.departArr = res.data;
            },
            orderExport(){
                let loginInfo = JSON.parse(localStorage.getItem('loginInfo'));
                var auth = "&sid=" + loginInfo.sid + '&token=' + loginInfo.token + '&uid=' + loginInfo.admin_id;
                var query = Object.keys(this.search).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.search[key])}`).join('&')
                if(this.selectedOrders.length){
                    query += '&ids=' + this.selectedOrders.map(v => v.id).join(',');
                }
                var url = base.domain + '/admin/crm/orderExport?' + query + auth;
                console.log(url);
                window.open(url);
                this.exportVisible = false;
            },
            handleSelectionChange(selection) {
                this.selectedOrders = selection;
            },
            async handleCommand(e) {
                console.log('handleCommand', e)
                if(this.selectedOrders.length < 1){
                    return this.$message.error('请选择订单');
                }
                let err = '';
                if(e == 'check'){
                    this.selectedOrders.forEach(order => {
                        if(!order.can_check){
                            err = order.order_no + '订单不可审核';
                        }
                    });
                    if(err){
                        return this.$message.error(err);
                    }
                    // try {
                    //     const promises = this.selectedOrders.map(async (order) => {
                    //         var res = await crmorderCheck({ id: order.id, check_state: 30 });
                    //         if (res.code != 0) {
                    //             throw new Error(order.order_no + res.msg);
                    //         }
                    //         return res;
                    //     });

                    //     // 等待所有请求完成
                    //     await Promise.all(promises);

                    //     this.$message.success('审核成功');
                    // } catch (error) {
                    //     return this.$message.error(error.message);
                    // }

                    var res = await crmorderCheck({ id: this.selectedOrders.map(v => v.id).join(','), from: 'batch'});
                    if (res.code != 0) {
                        return this.$message.error(res.msg);
                    }

                    this.getOrderLists();
                }
                if(e == 'receive'){  // 订单签收
                    this.selectedOrders.forEach(order => {
                        if(!order.can_receive){
                            err = order.order_no + '订单不可签收';
                        }
                    });
                    if(err){
                        return this.$message.error(err);
                    }
                    this.signType = 2;
                    this.signState = 60;
                    this.signVisible = true;
                }else if(e == 'jdexpress'){  // 京东物流发货
                    this.selectedOrders.forEach(order => {
                        if(!order.can_send){
                            err = order.order_no + '订单不可发货';
                        }
                        if(order.deliver_type != 1){
                            err = order.order_no + '订单发货方式不是快递物流';
                        }
                    });
                    if(err){
                        return this.$message.error(err);
                    }

                    this.$confirm('选中订单使用京东物流发货, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        // try {
                        //     const promises = this.selectedOrders.map(async (order) => {
                        //         var res = await crmorderSend({ id: order.id});
                        //         if (res.code != 0) {
                        //             throw new Error(order.order_no + res.msg);
                        //         }
                        //         return res;
                        //     });

                        //     await Promise.all(promises);

                        //     this.$message.success('发货成功');
                        // } catch (error) {
                        //     return this.$message.error(error.message);
                        // }

                        var res = await crmorderSend({ id: this.selectedOrders.map(v => v.id).join(','), from: 'batch'});
                        if (res.code != 0) {
                            return this.$message.error(res.msg);
                        }

                        this.getOrderLists();
                    }).catch(() => { });
                }else if(e == 'cancel'){  // 取消订单
                    let ids = [];
                    this.selectedOrders.forEach(order => {
                        if(!order.can_cancel){
                            err = order.order_no + '订单不可取消';
                        }
                        ids.push(order.id);
                    });
                    if(err){
                        return this.$message.error(err);
                    }
                    this.$confirm('订单取消不可恢复，请谨慎操作！, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(async () => {
                        this.cancelHandle(ids);
                    }).catch(() => { });
                }else if(e == 'dispatch'){
                    this.dispatchVisible = true;
                    this.dispatchAdminId = '';
                    this.selectAdmin(true);
                }
            },
            async handleAction(type, order) {
                this.currentOrder = order;
                this.action = type;
                switch (type) {
                    case 'edit':
                        this.orderVisible = true;
                        break;
                    case 'audit':
                        this.orderVisible = true;
                        break;
                    case 'pay':
                        this.orderVisible = true;
                        break;
                    case 'ship':
                        this.orderVisible = true;
                        break;
                    case 'logistics':
                        let res = await crmorderLogistics({ id: order.id, express_sn: order.express_sn, express_no: order.express_no });
                        if (res.code != 0) {
                            return this.$message.error(res.msg);
                        }
                        this.logisticsData = res.data;
                        this.logisticsVisible = true;
                        break;
                    case 'follow':
                        this.followForm.follow_state = this.currentOrder.follow_state;
                        this.followForm.content = this.currentOrder.follow_content;
                        this.followVisible = true;
                        break;
                    case 'sign':
                        this.signType = 1;
                        this.signState = 60;
                        this.signVisible = true;
                        break;
                    case 'confirm':
                        this.$prompt('订单到款金额：', '订单确款', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            inputValue: (order.pay_amount - order.pre_money).toFixed(2),
                            inputPattern: /^\d+(\.\d{1,2})?$/,
                            inputErrorMessage: '金额不正确'
                        }).then(async ({ value }) => {
                            let res = await crmorderConfirm({id: order.id, amount: value});
                            if (res.code != 0) {
                                return this.$message.error(res.msg);
                            }
                            this.$message.success(res.msg || '操作成功');
                            this.getOrderLists();
                        }).catch(() => {});return;
                        break;
                    case 'print':
                        return this.print(order);
                        if(!this.company.company_name){
                            res = await firmInfoDeatail();
                            if (res.code !== 0) {
                                this.company.company_name = '';
                            }else{
                                this.company = res.data;
                            }
                        }
                        this.printVisible = true;
                        break;
                    case 'cancel':
                        this.$confirm('订单取消不可恢复，请谨慎操作！, 是否继续?', '订单取消', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async () => {
                            this.cancelHandle([order.id]);
                        }).catch(() => { });
                        break;
                    default:
                        console.log('Unknown action type:', type);
                }
            },
            closeEdit() {
                this.orderVisible = false;
                this.getOrderLists();
            },
            handleChange(file) {
                this.mutipartFile = new FormData();
                this.mutipartFile.append("file", file.raw);
                this.upfilename = file.name;
            },
            async upsubmit(){
                if(!this.mutipartFile || !this.mutipartFile.get("file")){
                    return this.$message.error("请选择文件");
                }
                this.uploading = true;
                let res = await orderImportExpress(this.mutipartFile);
                this.uploading = false;
                if (res.code != 0) {
                    this.$confirm(res.msg, '导入失败', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    }).then().catch();
                    return;
                }

                this.$alert(res.data, '导入结果', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.importVisible = false;
                        this.getOrderLists();
                    }
                });
            },
            async comfirmsubmit(){
                if(!this.mutipartFile || !this.mutipartFile.get("file")){
                    return this.$message.error("请选择文件");
                }
                this.uploading = true;
                let res = await orderBatchConfirm(this.mutipartFile);
                this.uploading = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.comfirmVisible = false;
                this.getOrderLists();
            },
            async receivesubmit(){
                if(!this.mutipartFile || !this.mutipartFile.get("file")){
                    return this.$message.error("请选择文件");
                }
                this.uploading = true;
                let res = await orderBatchReceive(this.mutipartFile);
                this.uploading = false;
                if (res.code != 0) {
                    this.$confirm(res.msg, '签收失败', {
                        confirmButtonText: '确定',
                        type: 'warning'
                    }).then().catch();
                    return;
                }

                this.$alert(res.data, '导入结果', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.receiveVisible = false;
                        this.getOrderLists();
                    }
                });
            },
            async signOrderHandle(){
                let ids = this.signType == 1 ? [this.currentOrder.id] : this.selectedOrders.map(v => v.id);
                let res = await crmorderReceive({ids, state: this.signState});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '操作成功');
                this.signVisible = false;
                this.getOrderLists();
            },
            async cancelHandle(ids){
                let res = await crmorderCancel({ids});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '取消成功');
                this.getOrderLists();
            },
            async followHandle(){
                let res = await crmorderFollow({id: this.currentOrder.id, follow_state: this.followForm.follow_state, content: this.followForm.content});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '操作成功');
                this.followVisible = false;
                this.getOrderLists();
            },
            async todoHandle(){
                let res = await todoAdd({...this.todoForm, type: 2, follow_order_id: this.currentOrder.id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '操作成功');
                this.todoVisible = false;
            },
            async print(row) {
                if(!this.company.company_name){
                    let res = await firmInfoDeatail();
                    if (res.code !== 0) {
                        this.company.company_name = '';
                    }else{
                        this.company = res.data;
                    }
                }

                let table = '<table>';
                table += '<thead>';
                table += '<tr><th>序号</th> <th>商品名称</th> <th>规格</th> <th>数量</th> <th>单价</th> <th>金额</th></tr>';
                table += '</thead><tbody>';
                row.goods.forEach((good, index) => {
                    table += '<tr>';
                    table += `<td>${index + 1}</td>`;
                    table += `<td>${good.good_name}</td>`;
                    table += `<td>${good.spec_data_str}</td>`;
                    table += `<td>${good.quatity}</td>`;
                    table += `<td>${good.sale_price}</td>`;
                    table += `<td>${good.amount}</td>`;
                    table += '</tr>';
                });
                table += '</tbody></table>';

                table += '<div style="display: flex;flex-direction: column;border-bottom: 1px solid #eee;padding: 10px 0;">';
                table += `<div style="display: flex;justify-content: space-between;"><span>商品：￥${row.good_amount}</span> <span>加价：￥${row.add_amount}</span> <span>优惠：￥${row.reduce_amount}</span></div>`;
                table += `<div style="margin-top: 10px;"><span>合计：${numToRMB(row.pay_amount)}</span><span style="margin-left: 20px;">￥${row.pay_amount}</span></div>`;
                table += '</div>';

                const printContent = `
                <h3 style="text-align: center;">${this.company.company_name}业务订单</h3>
                <div style="display: flex;justify-content: space-between;">
                    <div style="display: flex;">
                        <div>客户：</div>
                        <div>
                            <div>${row.receive_name}<span style="margin-left: 10px;">${row.receive_phone}</span></div>
                            <div style="margin-top: 10px;">${row.receive_province}${row.receive_city}${row.receive_area}${row.receive_street}</div>
                            <div style="margin-top: 10px;">${row.receive_address}</div>
                        </div>
                    </div>
                    <div style="display: flex;flex-direction: column;">
                        <div>单号：${row.order_no}</div>
                        <div>打单：${row.created_time}</div>
                    </div>
                </div>
                <div style="margin: 10px 0;">备注：${row.remark}</div>
                ${table}
                <div style="display: flex;justify-content: space-between;margin-top: 20px;">
                    <div>制单：<span>${row.admin.nick_name}<span style="margin-left: 10px;">${row.admin.phone}</span></span></div>
                    <div>客户：${row.user.name}<span style="margin-left: 10px;">${row.user.phone}</span></div>
                </div>
                `;
                
                const iframe = document.createElement('iframe');
                iframe.style.cssText = 'position:absolute;width:0;height:0;left:-9999px;';
                document.body.appendChild(iframe);
                
                iframe.contentDocument.write(`
                    <html>
                    <head>
                        <style>
                            table { border-collapse: collapse; width: 100%; }
                            th, td { border: 1px solid #ddd; padding: 8px; }
                            @page { margin: 0; }
                            body { margin: 1.6cm; } /* 内容安全边距 */
                        </style>
                    </head>
                    <body>${printContent}</body>
                    </html>
                `);
                
                iframe.contentWindow.print()
                setTimeout(() => iframe.remove(), 1000);
            },
            async getJdStatus(){
                this.jdStatusLoading = true;
                let res = await jdStatus();
                this.jdStatusLoading = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '操作成功');
                this.getOrderLists();
            },
            batchImport(command) {
                if(command == 'express'){
                    this.importVisible = true;
                }else if(command == 'confirm'){
                    this.comfirmVisible = true;
                }else if(command == 'receive'){
                    this.receiveVisible = true;
                }
            },
            async dispatchSubmit(){
                if(this.dispatchAdminId == 0){
                    return this.$message.error('请选择员工');
                }

                let res = await orderDispath({ids: this.selectedOrders.map(v => v.id).join(','), admin_id: this.dispatchAdminId});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '操作成功');
                this.dispatchVisible = false;
                this.getOrderLists();
            },

            openState(row){
                this.stateNew = '';
                this.stateRow = row;
                this.stateTitle = '修改订单状态 - ' + row.order_no;
                this.stateVisible = true;
            },
            async statesubmit(){
                if(this.stateNew == ''){
                    return this.$message.error('请选择状态');
                }
                this.stateloading = true;
                let res = await orderStateChange({id: this.stateRow.id, state: this.stateNew});
                this.stateloading = false;
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '操作成功');
                this.stateVisible = false;
                this.getOrderLists();
            }
        }
    }
</script>

<style scoped>
.button-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.button-container .el-button {
    flex: 0 0 45%;
    margin: 5px 0;
}

.search-container {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: start;
    gap: 10px;
    padding-bottom: 10px;
}
.left-part {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    transition: max-height 0.3s ease;
}
.left-part.collapsed {
    overflow: hidden;
    max-height: 38px;
}
.right-part {
    display: flex;
    justify-content: flex-end;
    gap: 5px;
    align-items: center;
}
.left-part .el-input {
    width: 150px;
}
.right-part a._color {
    width: 80px;
    text-align: center;
}
</style>